import { useTranslation } from "react-i18next";
import FilterDatePicker from "./FilterDatePicker";
import dayjs from "dayjs";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, useTheme } from "@mui/material";
import { Q3DSelect } from "../../Parts/Q3DSelect";

type Props = {
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
};

export const buildDateNavSearch = (
  currentSearch: string,
  dateFrom: dayjs.Dayjs | null,
  dateTo: dayjs.Dayjs | null
): string => {
  const params = new URLSearchParams(currentSearch);
  const from = dayjs(dateFrom);
  const to = dayjs(dateTo);
  !dateFrom
    ? params.delete("from")
    : params.set("from", from.format("YYYY-MM-DD"));
  !dateTo ? params.delete("to") : params.set("to", to.format("YYYY-MM-DD"));
  params.delete("sortBy");
  return params.toString();
};

export const FilterDate = (props: Props) => {
  const location = useLocation();
  const search = location.search;
  const params = new URLSearchParams(search);
  const from = params.get("from");
  const to = params.get("to");
  // state
  const [dateFrom, setDateFrom] = useState(from ? dayjs(from) : null);
  const [dateTo, setDateTo] = useState(to ? dayjs(to) : null);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    navigate(`?${buildDateNavSearch(search, dateFrom, dateTo)}`);
  }, [dateFrom, dateTo, navigate]);

  useEffect(() => {
    if (location.search.length > 0) return;
    const params = new URLSearchParams(search);
    const from = params.get("from");
    const to = params.get("to");
    setDateFrom(from ? dayjs(from) : null);
    setDateTo(to ? dayjs(to) : null);
  }, [location]);

  return (
    <>
      <Q3DSelect
        label={t("SORT_BY")}
        items={[
          { value: "create", label: t("CAPTURED_DATE") },
          { value: "upload", label: t("UPLOAD_DATE") },
        ]}
        value={props.sortBy}
        setValue={props.setSortBy}
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.base.border,
            borderWidth: "2px",
          },
        }}
      />
      <FilterDatePicker
        label={"From"}
        value={dateFrom}
        setValue={setDateFrom}
        shouldDisableDate={(date) => {
          return dayjs(date).isAfter(dateTo);
        }}
      />
      <Typography
        component="span"
        color={theme.palette.base.contrast}
        sx={{ fontSize: "20px" }}
      >
        ～
      </Typography>
      <FilterDatePicker
        label={"To"}
        value={dateTo}
        setValue={setDateTo}
        shouldDisableDate={(date) => {
          return dayjs(date).isBefore(dateFrom);
        }}
      />
    </>
  );
};
